interface ApiConfig {
  provider: 'openai' | 'groq';
  apiKey: string;
}

const defaultConfig: ApiConfig = {
  provider: 'openai',
  apiKey: import.meta.env.VITE_OPENAI_API_KEY || ''
};

let currentConfig: ApiConfig = { ...defaultConfig };

export function getApiConfig(): ApiConfig {
  return currentConfig;
}

export function updateApiConfig(config: ApiConfig) {
  currentConfig = { ...config };
  localStorage.setItem('apiConfig', JSON.stringify(config));
}

// Load saved config on initialization
try {
  const savedConfig = localStorage.getItem('apiConfig');
  if (savedConfig) {
    currentConfig = { ...JSON.parse(savedConfig) };
  }
} catch (error) {
  console.error('Failed to load saved API config:', error);
}